import { render, staticRenderFns } from "./Battle.vue?vue&type=template&id=6b32dc32&scoped=true"
import script from "./Battle.vue?vue&type=script&lang=js"
export * from "./Battle.vue?vue&type=script&lang=js"
import style0 from "./Battle.vue?vue&type=style&index=0&id=6b32dc32&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b32dc32",
  null
  
)

export default component.exports